import Api from "@/services/api";

const basic = "param";
export default {
  get() {
    return Api.default().get("/" + basic);
  },
};
